import { Flex, Stack, Text, desktopFirstMediaQuery } from '@inflearn/ds-react';
import { isNil } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import useClientAccountProfileQuery from '../../../../../queries/useClientAccountProfileQuery';
import { CourseCardMenu } from './CourseCardMenu';
import { FeedbackButtons } from './FeedbackButtons';
import type { CourseCardData } from './courseCardDataTransformer';

type Props = {
  hasCertificate: boolean;
  isArchived: boolean;
  isArchivable: boolean;
  isCancelable: boolean;
  course: CourseCardData['course'];
  voucherId: number;
  isReviewable: boolean;
  review: CourseCardData['review'];
};

export const OfflineCourseCardMetaInfo = ({
  hasCertificate,
  isArchived,
  isArchivable,
  isCancelable,
  course,
  voucherId,
  isReviewable,
  review,
}: Props) => {
  const { t } = useTranslation();
  const { data: profile } = useClientAccountProfileQuery();

  return (
    <Stack
      justify="space-between"
      css={{
        height: 88,
        [desktopFirstMediaQuery.mobile]: {
          height: 'auto',
          '.duration': {
            marginBottom: 8,
          },
        },
      }}
    >
      <Text
        css={{
          fontSize: 14,
          [desktopFirstMediaQuery.mobile]: {
            fontSize: 12,
          },
        }}
        color="gray.6"
        className="duration"
      >
        <Text weight={600} component="strong">
          {course.offlineCourse?.duration}
        </Text>{' '}
        {t('(한국 표준시)')}
      </Text>
      <Flex justify="space-between" align="center">
        <FeedbackButtons
          isReviewable={isReviewable}
          review={review}
          voucherId={voucherId}
          course={course}
        />

        <CourseCardMenu
          hasCertificate={hasCertificate}
          isOfflineCourse={course.isOfflineCourse}
          isCancelable={isCancelable}
          isArchivable={isArchivable}
          isArchived={isArchived}
          courseId={course.courseId}
          voucherId={voucherId}
          isPartners={!isNil(profile?.marketingPartner)}
        />
      </Flex>
    </Stack>
  );
};
